import { useCallback, useEffect } from 'react';
import clsx from 'clsx';
import {
  availabilityCollectionPeriodsLoadingSelector,
  availabilityCollectionPeriodsSelectedPeriodSelector,
  availabilityCollectionPeriodsSelector,
  createUnsavePeriod,
  fetchAvailabilityCollectionPeriods,
  setSelectedPeriod,
} from 'slices/availabilityCollectionPeriod.slice';
import { useAppDispatch, useAppSelector } from 'slices/store';
import type { TAvailabilityCollectionPeriod } from 'types/availabilityCollectionPeriod.type';
import { Button, EditableTable } from '@timeedit/ui-components';
import { Flex, Space, Spin } from '@timeedit/ui-components/antd';

const columns = [
  {
    title: 'Name',
    dataIndex: 'name',
    key: 'name',
  },
  {
    title: 'Start Time',
    dataIndex: 'periodStart',
    key: 'periodStart',
    render: (periodStart: string) => periodStart ?? '-',
  },
  {
    title: 'End Time',
    dataIndex: 'periodEnd',
    key: 'periodEnd',
    render: (periodEnd: string) => periodEnd ?? '-',
  },
  {
    title: 'Expiration Time',
    dataIndex: 'periodDeadline',
    key: 'periodDeadline',
    render: (periodDeadline: string) => periodDeadline ?? '-',
  },
];

const Periods = () => {
  const periods = useAppSelector(availabilityCollectionPeriodsSelector);
  const isLoading = useAppSelector(
    availabilityCollectionPeriodsLoadingSelector
  );
  const selectedPeriod = useAppSelector(
    availabilityCollectionPeriodsSelectedPeriodSelector
  );

  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(fetchAvailabilityCollectionPeriods());
  }, []);
  const onCreate = useCallback(() => {
    dispatch(createUnsavePeriod());
  }, [dispatch]);

  const onRowClick = useCallback((record) => {
    dispatch(setSelectedPeriod(record));
  }, []);

  const rowClassName = useCallback(
    (record: TAvailabilityCollectionPeriod) =>
      clsx({
        ['ant-table-row-selected']: record && selectedPeriod?.id === record.id,
      }),

    [selectedPeriod]
  );

  const footer = useCallback(
    () => (
      <Flex style={{ width: '100%' }} justify="space-between">
        <Flex gap="small" justify="flex-start">
          <Button size="small" type="primary" onClick={onCreate}>
            Create new
          </Button>
        </Flex>
      </Flex>
    ),
    [onCreate]
  );

  return (
    <Space direction="vertical" style={{ width: '100%' }}>
      <Spin spinning={isLoading}>
        <EditableTable
          rowKey="id"
          columns={columns}
          dataSource={periods}
          footer={footer}
          rowClassName={rowClassName}
          onRow={(record) => ({
            onClick: () => onRowClick(record),
          })}
        />
      </Spin>
    </Space>
  );
};

export default Periods;
